import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type NewTitleGraphqlFragment = {
	__typename?: 'NewTitlesEdge';
	cursor: string;
	newOffer?: {
		__typename?: 'Offer';
		id: string;
		standardWebURL?: string | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		lastChangeRetailPrice?: string | null;
		lastChangeRetailPriceValue?: number | null;
		lastChangePercent?: number | null;
		currency?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		newElementCount?: number | null;
		package: { __typename?: 'Package'; id: string; packageId: number; clearName: string; shortName: string };
	} | null;
	node:
		| {
				__typename?: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					shortDescription?: string | null;
					fullPath: string;
					posterUrl?: string | null;
					runtime?: number | null;
					isReleased: boolean;
					scoring: {
						__typename?: 'Scoring';
						imdbVotes?: number | null;
						imdbScore?: number | null;
						tmdbPopularity?: number | null;
						tmdbScore?: number | null;
					};
					genres: Array<{ __typename?: 'Genre'; translation: string }>;
					upcomingReleases?: Array<{
						__typename?: 'UpcomingRelease';
						releaseDate?: any | null;
						releaseCountDown?: number | null;
						package?: { __typename?: 'Package'; id: string; shortName: string } | null;
					}>;
				};
				availableTo?: Array<{
					__typename?: 'AvailableTo';
					availableCountDown: number;
					availableToDate: any;
					package: { __typename?: 'Package'; id: string; shortName: string };
				}>;
		  }
		| {
				__typename?: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				show: {
					__typename?: 'Show';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					content: {
						__typename?: 'ShowContent';
						title: string;
						shortDescription?: string | null;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						scoring: {
							__typename?: 'Scoring';
							imdbVotes?: number | null;
							imdbScore?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
						};
						genres: Array<{ __typename?: 'Genre'; translation: string }>;
					};
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					seenState: { __typename?: 'ShowSeenState'; progress: number };
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					shortDescription?: string | null;
					fullPath: string;
					posterUrl?: string | null;
					runtime?: number | null;
					isReleased: boolean;
					scoring: {
						__typename?: 'Scoring';
						imdbVotes?: number | null;
						imdbScore?: number | null;
						tmdbPopularity?: number | null;
						tmdbScore?: number | null;
					};
					genres: Array<{ __typename?: 'Genre'; translation: string }>;
					upcomingReleases?: Array<{
						__typename?: 'UpcomingRelease';
						releaseDate?: any | null;
						releaseCountDown?: number | null;
						package?: { __typename?: 'Package'; id: string; shortName: string } | null;
					}>;
				};
				availableTo?: Array<{
					__typename?: 'AvailableTo';
					availableCountDown: number;
					availableToDate: any;
					package: { __typename?: 'Package'; id: string; shortName: string };
				}>;
		  };
};

export const NewTitleGraphqlFragmentDoc = gql`
	fragment NewTitleGraphql on NewTitlesEdge {
		cursor
		newOffer(platform: $platform) {
			id
			standardWebURL
			package {
				id
				packageId
				clearName
				shortName
			}
			retailPrice(language: $language)
			retailPriceValue
			lastChangeRetailPrice(language: $language)
			lastChangeRetailPriceValue
			lastChangePercent
			currency
			presentationType
			monetizationType
			newElementCount
		}
		node {
			id
			objectId
			objectType
			content(country: $country, language: $language) {
				title
				shortDescription
				fullPath
				scoring {
					imdbVotes
					imdbScore
					tmdbPopularity
					tmdbScore
				}
				posterUrl(profile: $profile, format: $format)
				runtime
				genres {
					translation(language: $language)
				}
				... on SeasonContent {
					seasonNumber
				}
				upcomingReleases @include(if: $showDateBadge) {
					releaseDate
					package {
						id
						shortName
					}
					releaseCountDown(country: $country)
				}
				isReleased
			}
			availableTo(country: $country, platform: $platform, packages: $availableToPackages)
				@include(if: $showDateBadge) {
				availableCountDown(country: $country)
				package {
					id
					shortName
				}
				availableToDate
			}
			... on Movie {
				likelistEntry {
					createdAt
				}
				dislikelistEntry {
					createdAt
				}
				seenlistEntry {
					createdAt
				}
				watchlistEntry {
					createdAt
				}
			}
			... on Season {
				show {
					id
					objectId
					objectType
					content(country: $country, language: $language) {
						title
						shortDescription
						fullPath
						scoring {
							imdbVotes
							imdbScore
							tmdbPopularity
							tmdbScore
						}
						posterUrl(profile: $profile, format: $format)
						runtime
						genres {
							translation(language: $language)
						}
					}
					likelistEntry {
						createdAt
					}
					dislikelistEntry {
						createdAt
					}
					watchlistEntry {
						createdAt
					}
					seenState(country: $country) {
						progress
					}
				}
			}
		}
	}
`;
